import Request from './request';

export default class PricingService {
	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new PricingService();
	}

	searchPricing(search) {
		let page = search.page || 0;
		let size = search.size || 20;

		return Request.instance().post('/console/v1/pricing/search', { page, size });
	}

	getPricingById(id) {
		return Request.instance().get(`/console/v1/pricing/${id}`);
	}

	editPricing(payload) {
		return Request.instance().post('/console/v1/pricing', payload);
	}

	deletePricing(id) {
		return Request.instance().delete(`/console/v1/pricing/${id}`);
	}
}